import { render, staticRenderFns } from "./Oct.vue?vue&type=template&id=5daf3c05&scoped=true"
import script from "./Oct.vue?vue&type=script&lang=js"
export * from "./Oct.vue?vue&type=script&lang=js"
import style0 from "./Oct.vue?vue&type=style&index=0&id=5daf3c05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf3c05",
  null
  
)

export default component.exports